import React from 'react';

const PageNotFound = () => {
  return (
    <div className="pageNotFound">
      <h1>You shouldn't be here buddy</h1> <br/>
      <h1>Now get the fuck outta here</h1>
    </div>
  );
}

export default PageNotFound;
